var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuvalu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.384-114.616 256-255.999 256-141.385 0-256.001-114.616-256.001-256 0 .061 256.001-255.972 256.001-256 141.383 0 255.999 114.616 255.999 256z",
    fill: "#338af3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m122.435 256h86.342l-75.212-89.043-11.13 33.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.001 208.778-89.044-86.343h89.043z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f0f0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.001 0c-.016 0-.029 0-.043 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.315 256h.685c0-.23 0-.454 0-.685-.228.229-.456.457-.685.685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.001 133.565c0-45.045 0-74.561 0-133.565h-.043c-141.366.024-255.958 114.629-255.958 256h133.566v-75.211l75.211 75.211h46.54c.228-.228.456-.456.685-.685 0-17.247 0-32.636 0-46.537l-75.214-75.213z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.515 33.391c-40.039 22.799-73.325 56.085-96.124 96.124v126.485h66.783v-155.824-.002h155.826c0-21.063 0-41.129 0-66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.001 224.519-90.955-90.953h-31.48v.002l122.433 122.432h.002s0-21.707 0-31.481z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m279.406 422.957 5.526 17.006h17.881l-14.465 10.51 5.526 17.005-14.468-10.509-14.465 10.509 5.526-17.005-14.467-10.51h17.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.811 311.652 5.525 17.006h17.881l-14.465 10.511 5.527 17.005-14.468-10.509-14.465 10.509 5.526-17.005-14.468-10.511h17.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.493 144.696 5.526 17.006h17.881l-14.465 10.51 5.525 17.005-14.467-10.509-14.465 10.509 5.526-17.005-14.467-10.51h17.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.333 267.13 5.525 17.007h17.881l-14.465 10.51 5.526 17.005-14.467-10.509-14.465 10.509 5.526-17.005-14.468-10.51h17.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.046 382.959 15.935 8.119 12.643-12.643-2.796 17.659 15.931 8.118-17.662 2.798-2.797 17.661-8.116-15.933-17.662 2.799 12.643-12.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.046 316.177 15.935 8.118 12.643-12.643-2.796 17.66 15.931 8.117-17.662 2.798-2.797 17.661-8.116-15.932-17.662 2.798 12.643-12.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.698 358.984 15.935 8.119 12.643-12.643-2.796 17.659 15.931 8.118-17.662 2.798-2.797 17.661-8.116-15.934-17.662 2.8 12.643-12.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.698 216.003 15.935 8.118 12.643-12.643-2.796 17.66 15.931 8.117-17.662 2.798-2.797 17.661-8.116-15.932-17.662 2.798 12.643-12.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.635 214.289 15.935 8.118 12.643-12.643-2.797 17.66 15.932 8.117-17.662 2.798-2.797 17.661-8.116-15.932-17.662 2.798 12.643-12.643z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuvalu);
export default __webpack_public_path__ + "static/media/tuvalu.9ef2afb29742ea6dc20811ce4ed6cfe6.svg";
export { ForwardRef as ReactComponent };